export default __webpack_public_path__ + "static/media/G0615.34I-26365_-16205_0.1711031940000.c4488716.jpg";